import Vue from "vue";
import Router from "vue-router";
import AppContent from "./AppContent.vue";
import Register from "./Register.vue";
import Profile from "./Profile.vue";
import Cancellation from "./Cancellation.vue";
import FirstCash from "./FirstCash.vue";

import QueryContainer from "./components/query-container.vue";
import Checkout from "./components/checkout.vue";
import Confirmation from "./components/confirmation.vue";
import store from "./store";

Vue.use(Router);

const router = new Router({
	mode: "history",
	routes: [{
			name: "firstCash",
			path: "/firstCash/:action",
			component: FirstCash
		},
		{
			name: "register_checkout",
			path: "/register/:channel/checkout/:code?",
			component: Register
		},
		{
			name: "register",
			path: "/register/:channel/:code?",
			component: Register,
		},

		{
			name: "default_cancellation",
			path: "/:channel/cancellation/:code?",
			component: Cancellation
		},
		{
			path: "/:channel/:departmentOrProduct?",
			component: AppContent,
			children: [{
					name: "query",
					path: "",
					component: QueryContainer
				},
				{
					name: "profile",
					path: "profile/:section/:mode?",
					component: Profile
				},
				{
					name: "checkout",
					path: "checkout",
					component: Checkout,
					beforeEnter: (to, from, next) => {
						// check if we can checkout the reservation
						if (store.getters.canCheckout) return next();

						// if reservation is not valid for checkout -> return to query.
						return next({
							name: from.name || 'query',
							params: to.params
						});
					}
				},
				{
					name: "confirmation",
					path: "confirmation",
					component: Confirmation,
					beforeEnter: (to, from, next) => {
						// should only be able to access this page with a valid reservation.
						if (!store.state.reservation.ProfileInfos.Shipping.Communication.Email) {
							return next({
								name: "query",
								params: to.params,
							});
						}

						// reset reservation when we navigate to confirmation
						store.dispatch("resetReservation");
						next();
					},
				}
			]
		},
	]
});

export default router;